import AffixIcon from "@assets/svg/affix-signature";
import Button from "@src/components/button/Button01";
import { useAppSelector } from "@src/ducks/ducksHook";
import { selectedCancelDocument } from "@src/ducks/slices/signsecure.slice";
import CopyRightContent from "@src/screens/create-document/document-sent/copy-right";
import MobileHeader from "@src/screens/drawer-screens/drawer-header/mobile";
import { DrawerContext } from "@src/screens/drawer-screens/drawer-provider";
import { mobileSize } from "@src/utils/screensize-helper";
import React from "react";
import { Text, View } from "react-native";
import useStyles from "./styles.css";
import { selectedAuthGuestRole } from "@src/ducks/slices/auth.slice";

const DocumentCancelled = () => {
  const styles = useStyles();
  const { onActiveTab } = React.useContext(DrawerContext);
  const document = useAppSelector(selectedCancelDocument);
  const isGuest = useAppSelector(selectedAuthGuestRole);
  const isMobileSize = mobileSize();

  return (
    <>
      <View style={styles.drawer_item_header}>
        {isMobileSize && <MobileHeader /> && !isGuest}
      </View>
      <View style={styles.container}>
        {/* <AffixIcon name="docu-cancelled" /> */}
        <Text style={[styles.t_title]}>Document Has Been cancelled</Text>
        <Text style={[styles.t_notes]}>
          The document <Text style={styles.t_notes_bold} >“{document?.name}”</Text>
          {"\n"}has been cancelled. Everyone in the party will be notified.
        </Text>
        <Button
          onPress={() => onActiveTab("Dashboard")}
          label="Go to Dashboard"
          style={styles.btn_proceed}
          labelStyle={styles.labelStyle}
        />
      </View>
       <View style={styles.copyRightLocation}>
        <CopyRightContent />
      </View>
    </>
  );
};

export default DocumentCancelled;
